module.exports = __webpack_public_path__ + "static/fire-extinguisher-8174d0fed3aae6612218c2eaa5481bf1.svg";